















































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  helpers,
} from 'vuelidate/lib/validators';
import MaskedInput from 'vue-masked-input';
import Navigator from '../Study/Navigator.vue';
import {
  countries,
  states,
  provinces,
  germanyStates,
  israelDistricts,
  austrailiaStates,
  degrees,
} from '../../shared/constants';
import { DataProjectPIDegreeBase } from '../../shared/dataProject';
import { bus, store, client } from '../../shared';
import { UserInfo } from '../../shared/user';
import _ from 'lodash';
import { ToggleButton } from 'vue-js-toggle-button';
@Component({
  components: {
    MaskedInput,
    ToggleButton,
  },
})
export default class DataRepoInfo extends Vue {
  /* ------------- Data -------------------- */
  $v: any;
  isInvestigator: boolean = true;
  states: any = states;
  provinces: any = provinces;
  germanyStates: any = germanyStates;
  israelDistricts: any = israelDistricts;
  australiaStates: any = austrailiaStates;
  countries: any = countries;
  orcSelection?: boolean;
  activeSession: any = {};
  degrees: any = degrees;
  degreeOtherSelected: boolean = false;
  degreeOther: any;
  form: any = {
    firstName: '',
    lastName: '',
    title: null,
    hasORCID: false,
    rsnNoORCID: null,
    orcid: null,
    institution: '',
    phone: '',
    email: '',
    addressline1: null,
    addressline2: null,
    city: null,
    state: null,
    country: null,
    stateOther: null,
    province: null,
    zip: null,
    phoneExt: null,
    personId: '',
    role: '',
    degrees: [],
    degreeOther: '',
  };
  @Prop({ default: false }) resetFile: boolean;
  dataProjectPIDegrees: [] = [];
  selected: [];
  @Validations()
  validations: any = {
    form: {
      rowId: 0,
      degrees: { required },
      degreeOther: {
        requiredIf: requiredIf(
          (form: any) => this.form.degrees.indexOf(-9) !== -1,
        ),
      },
      firstName: { required },
      lastName: { required },
      title: { required },
      hasORCID: { required },
      rsnNoORCID: {
        requiredIf: requiredIf((form: any) => form.hasORCID === false),
      },
      orcid: {
        requiredIf: requiredIf((form: any) => form.hasORCID === true),
        orcValid: (value: any, vm: any, form: any) => {
          const result = false;
          const segments = _.split(value, '-');
          if (segments.length > 0 && this.form.hasORCID) {
            if (
              !_.isNaN(parseFloat(segments[0])) &&
              segments[0] >= 0.0 &&
              !_.isNaN(parseFloat(segments[1])) &&
              segments[1] >= 0.0 &&
              !_.isNaN(parseFloat(segments[2])) &&
              segments[2] >= 0.0 &&
              !_.isNaN(
                parseFloat(segments[3].substring(0, 2)) &&
                  segments[3].substring(0, 2) > 0.0,
              ) &&
              segments[3].substring(2, 4).indexOf('_') === -1
            ) {
              return true;
            }
          }
          // return  default value to false
          if (this.form.hasORCID === false) {
            return true;
          }
          {
            return false;
          }
        },
      },
      institution: { required },
      email: {
        required,
        email,
      },
      phone: {
        required,
        phoneValid: (value: any, vm: any, form: any) => {
          if (
            value !== undefined &&
            value !== null &&
            value.indexOf('_') === -1
          ) {
            return true;
          }
          return false;
        },
        usPhoneValid: (value: any, vm: any) => {
          const validationRegex = /^[ ]*(?:\+?(\d{1,5}))*[-. )]?(\d+)?[-. (]?([2-9]\d{2})*[-. )]*?(\d{2})*[-. )]*(\d{3,4})*[-. ]*(\d{4,20})[ ]*$/;
          if (
            this.form.country !== '' &&
            (this.form.country === 'United States' ||
              this.form.country === 'Canada') &&
            value !== null &&
            value.match(validationRegex)
          ) {
            return true;
          }
          if (
            this.form.country !== '' &&
            this.form.country !== 'United States' &&
            this.form.country !== 'Canada' &&
            value !== null
          ) {
            return true;
          }
          return false;
        },
      },
      addressline1: { required },
      addressline2: {},
      city: { required },
      country: { required },
      state: {
        requiredIf: requiredIf(
          (form: any) =>
            form.country !== '' &&
            form.country === 'United States' &&
            form.country !== 'Canada',
        ),
      },
      stateOther: {
        requiredIf: requiredIf(
          (form: any) =>
            form.country !== '' &&
            form.country !== 'United States' &&
            form.country !== 'Canada' &&
            (form.country === 'Germany' ||
              form.country === 'Australia' ||
              form.country === 'Israel'),
        ),
      },
      province: {
        requiredIf: requiredIf(
          (form: any) =>
            form.country !== '' &&
            form.country !== 'United States' &&
            form.country === 'Canada',
        ),
      },
      zip: { required },
      phoneExt: {},
    },
  };
  isValidName(value: any) {
    const char = String.fromCharCode(value.keyCode);
    if (/^[a-z\d\-_'.\s]+$/i.test(char)) {
      return true;
    } else {
      value.preventDefault();
    }
  }
  @Watch('form.phone')
  onPhoneChanged(value: any) {
    if (value === '') {
      this.form.phone = null;
    }
    this.$v.form.phone.$touch();
  }
  @Watch('form.addressline1')
  public onAddressLine1Changed(value: any) {
    if (value === '') {
      this.form.addressline1 = null;
      }
  }
  @Watch('form.addressline2')
  public onAddressLine2Changed(value: any) {
    if (value === '') {
      this.form.addressline2 = null;
    }
  }
  @Watch('form.city')
  public onCityChanged(value: any) {
    if (value === '') {
      this.form.city = null;
    }
  }
  @Watch('form.zip')
  public onZipChanged(value: any) {
    if (value === '') {
      this.form.zip = null;
    }
  }
  @Watch('form.phoneExt')
  public onPhoneExtChanged(value: any) {
    if (value === '') {
      this.form.phoneExt = null;
    }
  }
  @Watch('form.orcid')
  onORCIDChanged(value: any) {
    this.$v.form.orcid.$touch();
  }
  @Watch('form.hasORCID')
  public onHasORCIDChanged(newValue: boolean, oldValue: boolean) {
    if (newValue === true) {
      this.form.rsnNoORCID = null;
    } else {
      this.form.orcid = null;
    }
  }
  @Watch('form.country')
  public onCountryChanged(newValue: string, oldValue: string) {
    if (newValue === 'United States') {
      this.form.province = null;
      this.form.stateOther = null;
    } else {
      if (newValue === 'Canada') {
        this.form.state = null;
        this.form.stateOther = null;
      } else {
        if (newValue !== 'United States' && newValue !== 'Canada') {
          this.form.state = null;
          this.form.province = null;
        }
      }
    }
    if (newValue === '') {
      this.form.country = null;
    }
  }
  get userInfo() {
    return store.userInfo;
  }
    validateForm() {
    return this.$v.$invalid;
  }
  get phoneMasked() {
    if (
      this.form.country === 'United States' ||
      this.form.country === 'Canada'
    ) {
      return true;
    }
    return false;
  }
  submit() {
    this.$v.$touch();
    if (this.isInvestigator) {
      this.$emit('update', {
        formData: this.form,
        id: 1,
        isValid: !this.$v.$invalid,
      });
      }
  }
    activated() {
    if (
      this.userInfo.data !== undefined &&
      this.userInfo.data.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.data.form);
      this.loadDegrees();
    }
  }
  created() {
    bus.$on('userInfo', (info: any) => {
      // pre-populate the firstname, lastname, institution
      if (this.form.firstName === '') {
        this.form.firstName = info.userInfo.firstName;
      }
      if (this.form.lastName === '') {
        this.form.lastName = info.userInfo.lastName;
      }
      if (this.form.institution === '') {
        this.form.institution = info.userInfo.institution;
      }
      if (this.form.email === '') {
        this.form.email = info.userInfo.email;
      }
      this.submit();
    });
    if (
      this.userInfo.data !== undefined &&
      this.userInfo.data.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.data.form);
    }
  }
  degreeChange() {
    this.degreeOtherSelected =
      _.findIndex(this.form.degrees, (o: any) => o === -9) !== -1;
    setTimeout(() => {
      this.submit();
      this.loadDegrees();
    }, 10);
  }
    mounted() {
    this.loadToForm();
    if (localStorage.getItem('reloaded')) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem('reloaded');
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
    this.validateForm();
    this.loadDegrees();
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.data.form);
      this.loadDegrees();
      this.activeSession = JSON.parse(
        localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
      );

      if (!_.isEmpty(this.activeSession) && payload.data.form === undefined) {
        this.form.email = this.activeSession.email.slice(6);
        this.form.institution = this.activeSession.institution;
        this.form.addressline1 = this.activeSession.addressline1;
        this.form.addressline2 = this.activeSession.addressline2;
        this.form.city = this.activeSession.city;
        this.form.state = this.activeSession.state;
        if (this.activeSession.country !== undefined) {
          this.form.country = this.activeSession.country;
        }
        this.form.stateOther = this.activeSession.stateOther;
        this.form.province = this.activeSession.province;
        this.form.zip = this.activeSession.zip;
        this.form.phone = this.activeSession.phone;
        this.form.phoneExt = this.activeSession.phoneExt;
        this.form.personId = this.activeSession.personId;
        this.form.hasORCID = this.activeSession.hasORCID;
        this.form.rsnNoORCID = this.activeSession.rsnNoORCID;
        this.form.orcid = this.activeSession.orcid;
        this.form.title = this.activeSession.title;
        this.form.role = this.activeSession.role;
        this.form.rowId = this.activeSession.rowId;
        this.form.dataProjectId = this.activeSession.dataProjectID;
        this.form.part1complete = this.activeSession.part1complete;
      }
    });
  }
  loadDegrees() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.data.degreeList);
      this.form.degrees = this.userInfo.data.degreeList;
      this.form.degreeOther = this.userInfo.data.degreeOther;
      this.degreeOtherSelected = this.form.degrees.indexOf(-9) !== -1;
    });
  }
  @Watch('resetFile')
  public onResetFileChanged(newValue: boolean, oldValue: boolean) {
    this.clearFiles();
  }
  clearFiles() {
    /**/
  }
  public investigatorToggleChanged(changed: any) {
    this.$emit('is-investigator-changed', changed.value);
  }
}
